import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import Palette from '@opsbase/lib-palette';
import SelectionToolbar from '@opsbase/web-data-selection/SelectionToolbar';
import DeleteIcon from '@opsbase/web-icons/icons/DeleteIcon';
import EditIcon from '@opsbase/web-icons/icons/EditIcon';
import useNav from '@opsbase/web-nav/useNav';
import React, { useCallback, useMemo } from 'react';
export function TeamboardsSelectionToolbar() {
    const dataType = DataType.TEAMBOARD;
    const { goTo } = useNav();
    const handleClickEdit = useCallback(() => {
        goTo(Pages.TEAMBOARDS_MULTI_EDIT, { id: 'selected' });
    }, [goTo]);
    const handleClickDelete = useCallback(() => {
        goTo(Pages.TEAMBOARDS_DELETE, { id: 'selected' });
    }, [goTo]);
    const actions = useMemo(() => [
        {
            label: i18n.t('delete'),
            Icon: DeleteIcon,
            color: Palette.error,
            onClick: handleClickDelete,
        },
        {
            label: i18n.t('edit'),
            Icon: EditIcon,
            color: Palette.secondary,
            onClick: handleClickEdit,
        },
    ], [handleClickDelete, handleClickEdit]);
    return React.createElement(SelectionToolbar, { dataType: dataType, actions: actions });
}
export default TeamboardsSelectionToolbar;
